import { withRouter } from 'next/router'
import Link from 'next/link'

import LayoutBasic from '../layouts/layoutBasic'

import Feedback from '../components/feedback'
import {SeoMetaBasic} from '../components/seoMeta'

import {getLocalKeyValue} from '../storage'
import {GET, UPOST} from '../helpers'
import {TOKEN, GET_USER_URL} from '../vars'

class FeedbackPage extends React.Component  {
  static async getInitialProps(props) {
    let token =  await process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token

    let infoRequest, infoResponse={}
    if(token) {
      try {
        infoRequest = await GET(GET_USER_URL, token)
        infoResponse = await infoRequest.data
      } catch (e) {

      }
    }

    return {
      token: token,
      user: infoResponse.user,
      cart: infoResponse.cart,
    }
  }

  render() {
    let user = this.props.user

    return <LayoutBasic title="Picxy Customer Feedback" {...this.props}>
      <SeoMetaBasic {...this.props} name="Picxy Customer Feedback" description="Submit your valuable feedback" />
      <div className="container my-5">
        <div className="row justify-content-center mb-4">
          <div className="col-md-4">
            <Feedback user={user}/>
          </div>
        </div>
      </div>
    </LayoutBasic>
  }
}

export default withRouter(FeedbackPage)
